require('./basic-analysis.jade')
_ = require("lodash")

createChartOptions = (per_my, per_goal, per_all, element, NumberService) ->
  if per_my
    per_my_text = if per_my is 100 then per_my else NumberService.limitFractional(per_my)
  else
    per_my = 0
    per_my_text = '-'

  per_goal = per_goal || 0
  per_all = per_all || 0

  chart:
    renderTo: element[0]
    type: 'pie'
    backgroundColor: 'transparent'
  plotOptions:
    pie:
      borderWidth: 0
      shadow: false
      center: ['50%', '50%']
      enableMouseTracking: false
      dataLabels:
        enabled: false
  tooltip:
    enabled: false
  title:
    floating: true
    y: 80
    text: per_my_text + ' %'
    style:
      'fontSize': '24px'
      'color': '#008484'
  credits:
    enabled: false
  series: [
    size: 160,
    innerSize: 142,
    data: [
      color:'#979581'
      y: per_all
    ,
      color:'#b5bbb5'
      y: 100 - per_all
    ]
  ,
    size: 140,
    innerSize: 122,
    data: [
      color:'#ee2e2e'
      y: per_goal
    ,
      color:'#cf9c9c'
      y: 100 - per_goal
    ]
  ,
    size: 120,
    innerSize: 102,
    data: [
      color:'#008484'
      y: per_my
    ,
      color:'#87b6b6'
      y: 100 - per_my
    ]
  ]

BasicAnalysisDirective = (NumberService, BasicAnalysisService, $location, $routeParams, $filter)->
  restrict: "A"
  replace: false
  templateUrl: "analysis-charts/basic-analysis/basic-analysis.jade"
  scope:
    basicAnalysisData: '=basicAnalysisData'
  link: (scope, element) ->
    fairwayChartElement = element.find(".fairway-chart")
    girChartElement = element.find(".gir-chart")
    bogeyOnChartElement = element.find(".bogey-on-chart")
    path = $location.path()
    if $routeParams.event_id != undefined
      scope.hideLabel = true

    scope.displayNumber = (number, putt_disabled = false) ->
      if path.indexOf('round-detail') == 1 && putt_disabled && putt_disabled != 0
        return null
      if not angular.isNumber(number)
        return number
      $filter('number')(number , 2)


    scope.mixPanelEventPrefix =
      if path is '/'
        'DSB'
      else if path.indexOf('round-detail') > -1
        'DTL'
      else
        'ANL'

    scope.$watchCollection 'basicAnalysisData', ->
      viewModel = BasicAnalysisService.createViewModel(scope.basicAnalysisData)

      scope.my_avg = viewModel.my_avg
      scope.goal = viewModel.goal
      scope.all_members = viewModel.all_members
      scope.showRoundIcon = viewModel.showRoundIcon

      new Highcharts.Chart createChartOptions(scope.my_avg.per_fairway_center,
        scope.goal.per_fairway_center,
        scope.all_members.per_fairway_center,
        fairwayChartElement,
        NumberService)

      new Highcharts.Chart createChartOptions(scope.my_avg.per_par_on,
        scope.goal.per_par_on,
        scope.all_members.per_par_on,
        girChartElement,
        NumberService)

      new Highcharts.Chart createChartOptions(scope.my_avg.per_bogey_on,
        scope.goal.per_bogey_on,
        scope.all_members.per_bogey_on,
        bogeyOnChartElement,
        NumberService)

    scope.classForRoundIcons = ->
      switch scope.$parent.roundInfo?.round_type
        when 1.5 then 'icons-extra9'
        when 0.5 then 'icons-half-nine'
        else ''

BasicAnalysisDirective.$inject = [
  'NumberService'
  'BasicAnalysisService'
  '$location'
  '$routeParams'
  '$filter'
]

module.exports = BasicAnalysisDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/basic-analysis/basic-analysis-directive.coffee